exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column{background-color:#f5f5f6;width:200px;min-width:200px;height:calc(100vh - 80px);margin:0 .25rem}.column__header{display:flex;justify-content:space-between;font-size:1rem;padding:.5rem 1rem;margin-bottom:.5rem;background-color:#01579b;color:#fff}.column__body{padding:0 .5rem .5rem}.column .modal{padding:20px}.column .modal__header{float:right;text-align:center}.column .modal input,.column .modal textarea{border:none;width:100%;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66fffcdd","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Column.vue
// module id = 365
// module chunks = 0